<template>
  <a
    target="_blank"
    rel="noopener"
    :href="privacyPolicyUrl"
  ><slot>Privacy Policy</slot></a>
</template>

<script>
export default {
  name: 'PrivacyPolicyLink',
  data: function () {
    return {
      privacyPolicyUrl: 'https://www.authentigate.io/privacy-policy'
    }
  }
}
</script>
